import Tooltip from "devextreme-react/tooltip";
import { one } from "devextreme/events";
import React, { useEffect, useRef } from "react";

interface IGrantDetailCommentTooltipProps {
    commentText: string | null;
    commentUser: string | null;
    commentDate: string | null;
    target: string;
}
export default function GrantDetailCommentTooltip({ commentText, commentUser, commentDate, target }: IGrantDetailCommentTooltipProps) {

    const getTooltipContent = () => {

        if (commentText != null) {
            return (
                <div className="phase-comment-popup">
                    <p>Comment: </p>
                    <div
                        style={{ maxHeight: '200px', overflowY: 'auto', overscrollBehavior: 'contain' }}
                        onWheel={(e) => e.stopPropagation()}
                        dangerouslySetInnerHTML={{ __html: commentText }}
                    />
                    <br></br>
                    <p>User: {commentUser}</p>
                    <p>Date: {commentDate}</p>
                </div>
            );
        }
    };

    function normalizeTarget(target: string): string {
        if (target.startsWith("#")) {
            return target;
        }
        return `#${target}`;
    }

    if (commentText == null)
        return null;
    else
        return (
            <Tooltip
                contentRender={getTooltipContent}
                hideEvent={{ name: "mouseleave", delay: 50 }}
                onHiding={(e: any) => {
                    e.cancel = new Promise(cancel => {
                        setTimeout(() => {
                            const popupContainer = e.component.content().parentElement;
                            if (popupContainer != null) {
                                const isHover = popupContainer.parentNode.matches(':hover');
                                if (isHover) {
                                    one(popupContainer, 'mouseleave', () => {
                                        cancel(false);
                                    });
                                } else {
                                    cancel(false);
                                }
                            }
                        }, 50);
                    })
                }}
                showEvent={{ name: "mouseenter", delay: 500 }}
                target={`${normalizeTarget(target)}`}
                width={400}
            ></Tooltip>
        )
}